import { List } from 'immutable';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';

import AlbumTrackListItem from './AlbumTrackListItem';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const AlbumTrackList = props => {
  // @ts-expect-error TS(7006) FIXME: Parameter 'prop' implicitly has an 'any' type.
  const validatePropKey = prop => {
    return !isNil(prop);
  };

  const generateListKey = () => {
    return [
      // when any of these values change, it will ensure BackstageItemList gets rerendered
      // so that the item's source card options get updated.
      props.albumPandoraId,
      props.isCompilation,
    ]
      .filter(validatePropKey)
      .join(':');
  };

  // @ts-expect-error TS(6133) FIXME: 'pandoraId' is declared but its value is never rea... Remove this comment to see the full error message
  const generateListItemProps = (_pandoraId, index) => {
    const currentTrack = props.tracks[index];

    return {
      trackProps: currentTrack,
      albumPandoraId: props.albumPandoraId,
      isCompilation: props.isCompilation,
      releaseType: props.releaseType,
    };
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'track' implicitly has an 'any' type.
  const tracksIdList = List(props.tracks.map(track => track.id));

  return (
    <D.BackstageItemList
      listKey={generateListKey()}
      sourceItems={tracksIdList}
      elementHeight={props.elementHeight}
      generateListItemProps={generateListItemProps}
      // @ts-expect-error TS(2322) FIXME: Type 'ConnectedComponent<{ (props: any): Element; ... Remove this comment to see the full error message
      listItemComponent={AlbumTrackListItem}
    />
  );
};

AlbumTrackList.propTypes = {
  tracks: PropTypes.array,
  albumPandoraId: PropTypes.string,
  isCompilation: PropTypes.bool,
  releaseType: PropTypes.string,
  elementHeight: PropTypes.number,
};

export default AlbumTrackList;
